module.exports = __webpack_public_path__ + "static/media/acorn.37a02492.svg";